import s from './styles.module.scss';

export const AppVersion = () => {
  return <span className={s.appVersion}>{import.meta.env.VITE_APP_VERSION}</span>;
};
